import React from "react";
import "./App.css";
import "./styles/theme.css";
import "./styles/inner.css";
import "./styles/buttons.css";
import Main from "./containers/Main";
import { ThemeProvider } from "styled-components";
import { chosenTheme } from "./theme";
import { GlobalStyles } from "./global";
import Scene3D from "./components/scene3d/Scene3D";
import MouseEffects from "./components/mouseEffects/MouseEffects";
import ScrollProgress from "./components/scrollProgress/ScrollProgress";

function App() {
  return (
    <ThemeProvider theme={chosenTheme}>
      <>
        <GlobalStyles />
        <Scene3D />
        <ScrollProgress />
        <MouseEffects />
        <div>
          <Main theme={chosenTheme} />
        </div>
      </>
    </ThemeProvider>
  );
}

export default App;
